import {
  TEAM_AVAILABILITY_REQUEST,
  TEAM_AVAILABILITY_SUCCESS,
  TEAM_AVAILABILITY_FAILURE,
} from '../../../actions/constants/types';

const initialState = {
  isFetching: false,
  teamsAvailability: {},
};

function teamsAvailabilities(state = initialState, action) {
  switch (action.type) {
    case TEAM_AVAILABILITY_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case TEAM_AVAILABILITY_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        teamsAvailability: action.response.data,
      };
    }
    case TEAM_AVAILABILITY_FAILURE: {
      return {
        ...state,
        isFetching: false,
        teamsAvailability: null,
      };
    }
    default:
      return state;
  }
}

export default teamsAvailabilities;
